import { MasterAPIService } from "@app/services/Methods/api";
import { ImageUploadResponse } from "@app/types/API.types";

export const uploadImage = (data: FormData) =>
    MasterAPIService.post<ImageUploadResponse>("/image/upload", data);

export const getImage = (uuid: string) =>
    `${process.env.REACT_APP_MASTER_API_URL}/api/image/${uuid}`;
